import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { SearchSubRuleEditorData } from "../../state/SearchManagerV2/SubRuleEditorData";

const updateSearchSubRuleEditorData: Reducer<SearchSubRuleEditorData> = (
  state: SearchSubRuleEditorData = new SearchSubRuleEditorData(),
  action: Action<ActionType, SearchSubRuleEditorData>
) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_RESET:
      return new SearchSubRuleEditorData();
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_CONFIG_FETCHED:
      return { ...state, configuration: action.data };
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    case ActionType.SEARCH_MANAGER_V2_SUBRULE_EDITOR_DATA_UPDATED:
      let result = {
        ...state,
        editorData: {
          ...state.editorData,
          ...action.data,
        },
      };
      return result;
    default:
      return state;
  }
};

export default updateSearchSubRuleEditorData;
